import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { take } from 'rxjs';
import { AdminService } from '../../core/admin/admin.service';
import { UserClerkService } from '../../core/user/user-clerk.service';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminComponent {
  isAdmin = signal<boolean>(false);

  constructor(
    private userClerkService: UserClerkService,
    private adminService: AdminService
  ) {}

  ngOnInit() {
    this.userClerkService
      .getUser$()
      .pipe(take(1))
      .subscribe((data) => {
        if (data?.publicMetadata['isAdmin'] === true) {
          this.isAdmin.set(true);
        }
      });
  }
}
